import { CancelToken } from "axios";
import fetch from "auth/FetchInterceptor";

const ClientService = {};
const BASE_URL = "/client";

let cancelIndex;

ClientService.fetchAll = (term) => {
    if (cancelIndex) cancelIndex();

    return fetch({
        url: BASE_URL,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        cancelToken: new CancelToken(function executor(c) {
            cancelIndex = c;
        }),
        params: { term }
    });

}




ClientService.fetchClient = (id) =>
    fetch({
        url: `${BASE_URL}/${id}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

ClientService.postClient = (client) =>
    fetch({
        url: BASE_URL,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: client
    });

ClientService.patchClient = ({ id, client }) =>
    fetch({
        url: `${BASE_URL}/${id}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: client
    });
export default ClientService;